const initialState = {}

export const SET_FIELD_CONFIGS = 'SET_FIELD_CONFIGS'

export function setFieldConfigs(data: unknown) {
  return {
    type: SET_FIELD_CONFIGS,
    payload: data,
  } as const
}

type ActionTypes = ReturnType<typeof setFieldConfigs>

export function reducer(state = initialState, action: ActionTypes) {
  switch (action.type) {
    case SET_FIELD_CONFIGS:
      return action.payload
    default:
      return state
  }
}
